import { ILanguage } from "@edgetier/watchtower-types";

/**
 * Find the language name using the language ISO code in list of languages
 * @param languageCode  Language ISO code
 * @param languages     List of languages
 * @returns Language name or "unknown" or "none"
 */
export const displayLanguageName = (languageCode: string, languages?: ILanguage[]) => {
    if (Array.isArray(languages) && languages.length > 0) {
        const selectedLanguage = languages.find(({ languageIsoCode }) => languageCode === languageIsoCode);

        return typeof selectedLanguage !== "undefined" ? selectedLanguage.language : "Unknown";
    }

    return "All";
};
